/* istanbul ignore file */
import { DEFAULT_ENTITY_AUTHOR } from 'domain/shared/core/constants';
import { EntityHeader } from 'framework/ui/layout';
import { updateCurrencyName } from 'framework/utils';

const LedgerHeader = () => (
  <EntityHeader
    entityTitleSource="id"
    color="brand"
    entityTitle={data => updateCurrencyName(data.getValueBySource('id').replace(/[/]/g, ' / '))}
    defaultAuthor={DEFAULT_ENTITY_AUTHOR}
  />
);

export default LedgerHeader;
